import { ChannelManager } from '@ayocore/erp/crm/client/components/ChannelManager';
import type { ContactChannel } from '../../../../../schemas/contact-channel.schema';

interface LeadChannelsProps {
  entityUuid: string;
  contactChannels: ContactChannel[];
  onChannelsChanged: () => void;
}

export function LeadChannels({
  entityUuid,
  contactChannels,
  onChannelsChanged,
}: LeadChannelsProps) {
  return (
    <ChannelManager
      entityUuid={entityUuid}
      contactChannels={contactChannels}
      onChannelsChanged={onChannelsChanged}
    />
  );
}
